const defaultState = [];


export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_HERO_IMAGES':
      return action.heroImages;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/heroImages.js